import { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { Loader2, AlertTriangle } from "lucide-react";
import { ASSETS } from "@/lib/constants";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "grc_bdm_token";

export default function BDMAccess() {
  const { token } = useParams();
  const [err, setErr] = useState("");
  const nav = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${API}/bdm/access/${token}`);
        localStorage.setItem(TOKEN_KEY, data.access_token);
        nav("/bdmdashboard", { replace: true });
      } catch (e) {
        setErr(e?.response?.data?.detail || "That link didn't work.");
      }
    })();
  }, [token, nav]);

  if (!err) {
    return (
      <div className="min-h-screen bg-linen flex flex-col items-center justify-center gap-4" data-testid="bdm-access-loading">
        <img src={ASSETS.logoHorizontal} alt="Great Rate Check" className="h-9 w-auto" />
        <Loader2 className="w-6 h-6 animate-spin text-teal" />
        <p className="text-sm text-ink-500">Opening your dashboard…</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-linen flex items-center justify-center px-4">
      <div className="w-full max-w-md text-center" data-testid="bdm-access-error">
        <Link to="/" className="inline-block mb-8">
          <img src={ASSETS.logoHorizontal} alt="Great Rate Check" className="h-9 w-auto" />
        </Link>
        <div className="bg-white border border-linen-border rounded-3xl shadow-soft p-8">
          <AlertTriangle className="w-7 h-7 text-amber-500 mx-auto" />
          <h1 className="mt-3 font-heading font-medium text-2xl text-navy">This link isn't working</h1>
          <p className="mt-2 text-sm text-ink-500">{err}</p>
          <div className="mt-6 flex flex-col gap-2">
            <Link
              to="/bdmlogin"
              data-testid="bdm-access-to-login"
              className="inline-flex justify-center items-center bg-navy text-white font-semibold text-sm px-5 py-2.5 rounded-full hover:bg-[#173a5f]"
            >
              Sign in with a password instead
            </Link>
            <a href="mailto:daren@greatratecheck.com" className="text-xs text-teal hover:underline">
              Ask for a new link
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
